import React from 'react';
import { useTranslation } from 'react-i18next';

import Asset5 from '../../assets/images/Asset5.svg';

import './index.scss';

function SmallFooter(){
  const { t } = useTranslation();
  return(
        <div className="small-footer-wrapper">
            <div className='end'>
                <img src={Asset5} alt=''/>
                <span>in Borscht we trust</span>
                <div className='icons'>
                    <a href="https://www.facebook.com/share/1DtL5rPEJQ/?mibextid=LQQJ4d" target="_blank"><div className='icon fb'></div></a>
                    <a href="https://www.instagram.com/borscht_nl?igsh=anJkdmFlY3Z4ZXF2&utm_source=qr" target="_blank"><div className='icon insta'></div></a>
                </div>
            </div>
        </div>
    )
}

export default SmallFooter; 